import React, { useState } from 'react';
import StatusBadge from './StatusBadge';
import styles from '../../styles/GestionInteresadosStyles/GestionInteresados.module.css';

function ProspectsTable({ prospects, filters, onFilterChange, onProspectClick, onEdit, onDelete, onUpdateEstado, page, totalPages, onPageChange }) {
  const [selectedRows, setSelectedRows] = useState([]);
  const [showFilters, setShowFilters] = useState({
    campus: false,
    responsable: false,
    estado: false
  });

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedRows(prospects.map(p => p.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id, checked) => {
    if (checked) {
      setSelectedRows(prev => [...prev, id]);
    } else {
      setSelectedRows(prev => prev.filter(rowId => rowId !== id));
    }
  };

  const toggleFilter = (filterType) => {
    setShowFilters(prev => ({
      ...prev,
      [filterType]: !prev[filterType]
    }));
  };

  const handleFilterSelect = (filterType, value) => {
    onFilterChange(filterType, value);
    setShowFilters(prev => ({
      ...prev,
      [filterType]: false
    }));
  };

  const getUniqueValues = (field) => {
    const values = [...new Set(prospects.map(p => p[field]))];
    return ['Todos', ...values];
  };

  const estadoOptions = ['Todos', 'NUEVO', 'SEGUIMIENTO', 'EN_ESPERA', 'EN_PROCESO', 'ACEPTADO', 'RECHAZADO', 'PERDIO_INTERES', 'MATRICULADO', 'INSCRITO'];

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableHeader}>
        <div className={styles.tableTitle}>
          <div className={styles.tableTitleIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <span>Lista de Prospectos</span>
        </div>
        
        <div className={styles.tablePagination}>
          <span>{page || 1} de {totalPages || 1}</span>
          <div className={styles.paginationControls}>
            <button
              className={styles.paginationButton}
              disabled={!page || page <= 1}
              onClick={() => onPageChange && onPageChange(page - 1)}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <polyline points="15,18 9,12 15,6"/>
              </svg>
            </button>
            <button
              className={styles.paginationButton}
              disabled={page >= totalPages}
              onClick={() => onPageChange && onPageChange(page + 1)}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <polyline points="9,18 15,12 9,6"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className={styles.tableContent}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.checkboxColumn}>
                <label className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    checked={selectedRows.length === prospects.length && prospects.length > 0}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    className={styles.checkbox}
                  />
                  <span className={styles.checkmark}></span>
                </label>
                <div className={styles.dropdownIcon}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M6 9l6 6 6-6"/>
                  </svg>
                </div>
              </th>
              
              <th className={styles.nameColumn}>
                <div 
                  className={`${styles.columnHeader} ${styles.clickableHeader}`} 
                  onClick={() => prospects.length > 0 && onProspectClick(prospects[0])}
                  title="Click para ver detalles del primer prospecto"
                >
                  <span>Nombre</span>
                  <div className={styles.headerIcons}>
                    <div className={styles.viewIcon}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </div>
                    <div className={styles.sortIcon}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M6 9l6 6 6-6"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </th>
              
              <th className={styles.campusColumn}>
                <div className={styles.columnHeader} onClick={() => toggleFilter('campus')}>
                  <span>Campus</span>
                  <div className={styles.filterIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </div>
                </div>
                {showFilters.campus && (
                  <div className={styles.filterDropdown}>
                    {getUniqueValues('campus').map(value => (
                      <div
                        key={value}
                        className={styles.filterOption}
                        onClick={() => handleFilterSelect('campus', value)}
                      >
                        {value}
                      </div>
                    ))}
                  </div>
                )}
              </th>
              
              <th className={styles.responsableColumn}>
                <div className={styles.columnHeader} onClick={() => toggleFilter('responsable')}>
                  <span>Responsable de seguimiento</span>
                  <div className={styles.filterIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </div>
                </div>
                {showFilters.responsable && (
                  <div className={styles.filterDropdown}>
                    {getUniqueValues('responsable').map(value => (
                      <div
                        key={value}
                        className={styles.filterOption}
                        onClick={() => handleFilterSelect('responsable', value)}
                      >
                        {value}
                      </div>
                    ))}
                  </div>
                )}
              </th>
              
              <th className={styles.estadoColumn}>
                <div className={styles.columnHeader} onClick={() => toggleFilter('estado')}>
                  <span>Estado</span>
                  <div className={styles.filterIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </div>
                </div>
                {showFilters.estado && (
                  <div className={styles.filterDropdown}>
                    {estadoOptions.map(value => (
                      <div
                        key={value}
                        className={styles.filterOption}
                        onClick={() => handleFilterSelect('estado', value)}
                      >
                        {value}
                      </div>
                    ))}
                  </div>
                )}
              </th>
              
              <th className={styles.actionsColumn}>
                <span>Acciones</span>
              </th>
            </tr>
          </thead>
          
          <tbody>
            {prospects.map((prospect) => (
              <tr key={prospect.id} className={styles.tableRow}>
                <td className={styles.checkboxCell}>
                  <label className={styles.checkboxContainer}>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(prospect.id)}
                      onChange={(e) => handleSelectRow(prospect.id, e.target.checked)}
                      className={styles.checkbox}
                    />
                    <span className={styles.checkmark}></span>
                  </label>
                </td>
                
                <td className={styles.nameCell}>
                  <button 
                    className={styles.nameButton}
                    onClick={() => onProspectClick(prospect)}
                  >
                    {prospect.nombre}
                  </button>
                </td>
                
                <td className={styles.campusCell}>
                  {prospect.campus}
                </td>
                
                <td className={styles.responsableCell}>
                  {prospect.responsable}
                </td>
                
                <td className={styles.estadoCell}>
                  <StatusBadge status={prospect.estado} />
                </td>
                
                <td className={styles.actionsCell}>
                  <div className={styles.actionButtons}>
                    <button 
                      className={styles.actionButton}
                      onClick={() => onProspectClick(prospect)}
                      title="Ver detalles"
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </button>

                    <button
                      className={styles.actionButton}
                      onClick={() => onEdit && onEdit(prospect)}
                      title="Editar"
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M12 20h9"/>
                        <path d="M16.5 3.5a2.121 2.121 0 113 3L7 19l-4 1 1-4 12.5-12.5z"/>
                      </svg>
                    </button>
                    
                    <button 
                      className={styles.actionButton}
                      title="Eliminar"
                      onClick={() => onDelete && onDelete(prospect.id)}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <polyline points="3,6 5,6 21,6"/>
                        <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ProspectsTable;
